import { render, staticRenderFns } from "./nfcScanner.vue?vue&type=template&id=70643786&scoped=true"
import script from "./nfcScanner.vue?vue&type=script&lang=js"
export * from "./nfcScanner.vue?vue&type=script&lang=js"
import style0 from "./nfcScanner.vue?vue&type=style&index=0&id=70643786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70643786",
  null
  
)

export default component.exports